import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { HomepalService } from '../../../common/service/data/homepal.service';
import { HomepalDashboardMenuItemModel } from '../../../common/model/homepal-dashboard-menu-item-model';
import { Subscription, interval } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { FormControlEx } from '../../../core/component/forms/form-control';
import { SelectionItem } from '../../../core/component/select/select.component';

@Component({
    selector: 'app-homepal-dashboards',
    templateUrl: './homepal-dashboards.component.html',
    styleUrls: ['./homepal-dashboards.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class HomepalDashboardsComponent implements OnInit, OnDestroy {
  constructor(
    private _dataService: HomepalService,
    fcf: FormControlExFactory,
    domSanitizer: DomSanitizer
  ) {
    this.selectionControl = fcf.create('INSIGHTS.SELECT_VIEW', null);
    this.selectedSub = this.selectionControl.valueChanges.subscribe(v => {
      let dashboard = this.dashboards.find(d => d.id == this.selectionControl.value);
      if (dashboard) this.selectedUrl = domSanitizer.bypassSecurityTrustResourceUrl(dashboard.url);
    });
  }

  selectedUrl: SafeResourceUrl;
  ngOnDestroy(): void {
    if (this.selectionSub) this.selectionSub.unsubscribe();
    if (this.timerSub) this.timerSub.unsubscribe();
    if (this.selectedSub) this.selectedSub.unsubscribe();
  }

  selectionControl: FormControlEx;
  dashboards: HomepalDashboardMenuItemModel[];
  selection: SelectionItem[] = [];

  ngOnInit() {
    this.updateSelection();
  }

  private selectionSub: Subscription;
  private timerSub: Subscription;
  private selectedSub: Subscription;

  updateSelection() {
    if (this.selectionSub) this.selectionSub.unsubscribe();

    this.selectionSub = this._dataService.get().subscribe(value => {
      if (!value.dashboards) return;

      this.selection = value.dashboards.map(d => new SelectionItem(d.title, d.id));
      this.dashboards = value.dashboards;
      if (!this.selectionControl.value && this.dashboards.length) this.selectionControl.setValue(this.dashboards[0].id);
      if (!this.timerSub && value.expiresInSeconds)
        this.timerSub = interval(value.expiresInSeconds * 1000).subscribe(() => {
          this.updateSelection();
        });
    });
  }
}
